<script lang="ts">
	import { NewsArticlePage } from '#lib/websites/news/pages/NewsArticlePage/index.js';
</script>

<NewsArticlePage showGlobalNav />
